import React from 'react';
import { Text as RNText, TextProps, StyleSheet } from 'react-native';
import { useTheme } from '../../theme/ThemeContext';

interface ThemedTextProps extends TextProps {
  variant?: 'light' | 'regular' | 'medium' | 'semibold' | 'bold';
}

export const ThemedText: React.FC<ThemedTextProps> = ({ 
  style, 
  variant = 'regular',
  ...props 
}) => {
  const { typography, theme } = useTheme();
  
  const fontFamily = typography.fontFamilies.inter[variant];
  
  return (
    <RNText 
      style={[
        { fontFamily, color: theme.text },
        style
      ]} 
      {...props} 
    />
  );
};

export default ThemedText;
